module.exports = __webpack_public_path__ + "static/img/cultureItem5.2d1a0e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/cultureItem5.png
// module id = e6Bl
// module chunks = 0